import { render, staticRenderFns } from "./MortgageAllActivities.vue?vue&type=template&id=1238ade3"
import script from "./MortgageAllActivities.vue?vue&type=script&lang=ts"
export * from "./MortgageAllActivities.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports